import React, { useReducer, useMemo, createContext } from "react";

import Header from "bodycodi/cmap/app/components/cmap2010/header";
import Body from "bodycodi/cmap/app/components/cmap2010/body";
import Footer from "bodycodi/cmap/app/components/cmap2010/footer";
import NoPartner from "./NoPartner";
import ScheduleDtlPop from "bodycodi/cmap/app/components/cmap2020/scheduleDtlPop";
import MemberDtlPop from "bodycodi/cmap/app/components/cmap3020/memberDtlPop";
import AddComunity from "bodycodi/cmap/app/components/cmap4010/addCommunity/index";
import AddSchedule from "../cmap2040/addSchedule";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";

const initialState = {
  bodyState: 0,
  mySchedule: {
    seqPartner: "",
    seqPartnerBranch: "",
    seqPartnerCoach: "",
    refresh: 0,
  },
  member: {
    seqPartner: "",
    seqPartnerBranch: "",
    seqPartnerCoach: "",
    refresh: 0,
  },
  comunity: {
    seqPartner: "",
    seqPartnerBranch: "",
    seqPartnerCoach: "",
    refresh: 0,
  },
  scheduleDtlPop: {
    seqPartner: "",
    seqPartnerbranch: "",
    seqPartnerCoach: "",
    seqSchedule: "",
    scheduleType: "",
    seqPartnerClassSchedule: "",
    update: () => {},
  },
  memberDtlPopData: { seqPartner: "", seqPartnerBranch: "", seqMember: "" },
};

export const DispatchContext = createContext<any | null>({ dispatch: () => {} });

export const StateContext = createContext<any | null>({ state: {} });

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case "UPDATE":
      return {
        ...state,
        ...action.data,
      };
    case "UPDATE_SCHDULE":
      const data: any = state.mySchedule;
      data.refresh = state.mySchedule.refresh + 1;
      return {
        ...state,
        ...data,
      };
    case "UPDATE_COMUNITY":
      const data1: any = state.comunity;
      data1.refresh = state.comunity.refresh + 1;
      return {
        ...state,
        ...data1,
      };
    case "CLICK_FOOTER":
      return {
        ...state,
        bodyState: action.state,
      };
    default:
      return state;
  }
};

const HomeWrap = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const stateValue = useMemo(() => ({ state: state }), [state]);
  const dispatchValue = useMemo(() => ({ dispatch: dispatch }), [dispatch]);

  return (
    <DispatchContext.Provider value={dispatchValue}>
      <StateContext.Provider value={stateValue}>
        <Home />
        <ScheduleDtlPop />
        <MemberDtlPop />
        <AddComunity />
        <AddSchedule />
      </StateContext.Provider>
    </DispatchContext.Provider>
  );
};

const Home = () => {
  const { partnerList, loading } = useSelector((state: RootState) => state.partner);

  return (
    <div className="app section-home">
      <Header />
      {!loading && !partnerList.length ? <NoPartner /> : <Body />}
      <Footer />
    </div>
  );
};

export default HomeWrap;
